import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import asyncPoll from 'react-async-poll';
import { eventGA } from '../../utils/googleAnalytics';
import { fetchHomepageAlerts, homepageAlertDismiss } from '../../actions/alerts';
import './styles.scss';

class PlayerAlert extends React.Component {

  constructor(props) {
    super(props);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.state = { firstPageLoad: true }
  }

  dismissMessage(type) {
    const { alertId, alertMessage, alertFeedId } = this.props;
    eventGA({
      category: 'Alert Interaction',
      action: `Player Alert ${type}`,
      label: alertId,
      dimension4: alertId,
      dimension5: alertMessage,
      dimension6: alertFeedId,
    });
    this.props.dispatch(homepageAlertDismiss(alertId));
  }

  componentDidMount() {
    setTimeout(function () {
      this.setState({ firstPageLoad: false })
    }.bind(this), 10 * 1000);
  }

  render() {
    const { currentItem, alertMessage, alertUrl, alertFeedId } = this.props;
    const { firstPageLoad } = this.state;
    const hasAlert = (alertMessage && alertFeedId != currentItem.id && !firstPageLoad) ? 'has-alert' : '';

    return (
      <div id="player-alert" className={`comment-alert player-alert ${hasAlert}`}>
        <span className="player-alert-content-wrap">
          <span className="content-holder">
            <span className="alert-message">{alertMessage}</span>
            <Link to={`/livecams${alertUrl}`} className="alert-action"
                  onClick={() => this.dismissMessage('Click')}>Watch Now</Link>
            <span className="close-button" onClick={() => this.dismissMessage('Close')}>
              <i className="icon-X_Close_Square"></i>
            </span>
          </span>
        </span>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentItem: state.currentItem.data,
    alertMessage: state.alerts.homepage.message,
    alertId: state.alerts.homepage.id,
    alertUrl: state.alerts.homepage.url,
    alertFeedId: state.alerts.homepage.feed_id,
  };
}

const onPollInterval = (props, dispatch) => {
  return dispatch(fetchHomepageAlerts());
};

export default connect(mapStateToProps)(asyncPoll(30 * 1000, onPollInterval)(PlayerAlert));
